module.exports = __webpack_public_path__ + "img/shiyuanhui big (4).63f3089d.jpg";